import { useContext, useEffect, useRef, useState } from "react";
import classes from "./FAQ.module.css";
import { Icon } from "@jds/core";
import { suggestionsTagObj } from "./data";
import { NewFileUploadContext } from "../Layout/NewFileUploadLayout/NewFileUploadLayout";

const FAQ = () => {
  const [isOpen, setIsOpen] = useState(false); // toggle modal
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [suggestion, setSuggestion] = useState("main");
  const [remainSuggestion, setRemainSuggestion] = useState([]);
  const faqContainerRef = useRef(null);
  const [previewSrc, setPreviewSrc] = useState(null);
  const handleImageClick = (src) => {
    setPreviewSrc(src);
  };

  const closePreview = () => {
    setPreviewSrc(null);
  };

  const initChat = [
    {
      role: "bot",
      content: greetingReturn(),
    },
    {
      role: "bot",
      content: <p>Hello, How can I help you today?</p>,
    },
  ];
  const [chatArr, setChatArr] = useState(initChat);
  const handleSuggestionClick = (suggestion) => {
    if (suggestion?.hasSuggestion) {
      setSuggestion(suggestion?.key);
    } else {
      setRemainSuggestion((pre) => [...pre, suggestion?.key]);
      // setSuggestion(false);
    }
    setChatArr((pre) => [
      ...pre,
      {
        role: "person",
        content: suggestion.personMsg,
      },
      {
        role: "bot",
        content: suggestion.botMsg,
      },
    ]);
  };
  const handleRestartChat = () => {
    setSuggestion("main");
    setChatArr(initChat);
    setRemainSuggestion([]);
  };
  useEffect(() => {
    const container = faqContainerRef.current;
    const section = container.querySelector(`#last-msg`);
    if (section && container) {
      container.scrollTo({
        top: section.offsetTop - 400,
        behavior: "smooth",
      });
    }
  }, [chatArr]);
  return (
    <div className={classes["faq-wrapper"]}>
      <div
        className={`${classes["faq-modal"]} ${isFullScreen ? classes["faq-modal-fullscreen"] : ""
          } ${isOpen ? classes["active"] : ""}`}
      >
        <div className={classes["faq-header"]}>
          <div className={classes["faq-heading"]}>
            <p>PhotoShare</p>
            <span>Welcome to PhotoShare FAQ Quick Assist! </span>
          </div>
          <div className={classes["faq-header-icon"]}>
            <div
              className={classes["header-icon"]}
              onClick={() => setIsFullScreen(!isFullScreen)}
              title={isFullScreen ? "Minimize Screen" : "Maximize Screen"}
            >
              <Icon
                ic={isFullScreen ? "IcFullscreenModeOff" : "IcFullscreenMode"}
              />
            </div>
            <div
              className={classes["header-icon"]}
              onClick={() => setIsOpen(!isOpen)}
              title={"Close"}
            >
              <Icon ic={"IcCloseRemove"} />
            </div>
          </div>
        </div>
        <div className={classes["faq-container"]} ref={faqContainerRef}>
          {chatArr.map((chat, i) => {
            const isLastMsg = i + 1 == chatArr.length;
            const showBotIcon =
              chat.role === "bot" && (i === 0 || chatArr[i - 1].role !== "bot");
            if (chat.role == "bot") {
              return (
                <BotMsg
                  {...chat}
                  isLastMsg={isLastMsg}
                  showIcon={showBotIcon}
                  onImageClick={handleImageClick}
                />
              );
            } else {
              return <PersonMsg {...chat} isLastMsg={isLastMsg} />;
            }
          })}
          {suggestion && (
            <div className={`${classes["suggestion-container"]}`}>
              {suggestionsTagObj[suggestion].map(
                (sug, i) =>
                  !remainSuggestion.includes(sug.key) && (
                    <SuggestionTag
                      lable={sug.lable}
                      onClick={handleSuggestionClick}
                      sug={sug}
                    />
                  )
              )}
            </div>
          )}
        </div>

        <div className={classes["faq-footer"]}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              cursor: "default",
            }}
          >
            <span style={{ color: "white", width: "80%", userSelect: "none" }}>
              ForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidthForFullWidth
            </span>

            <span
              style={{
                cursor: "pointer",
              }}
              onClick={handleRestartChat}
              title="Restart Chat"
            >
              <Icon ic={"IcGoForward"} />
            </span>
          </div>
        </div>
      </div>

      <div
        className={`${classes["faq-toggle-container"]}  ${!isOpen ? classes["active"] : ""
          }`}
      >
        <p>
          Quick Help?
          {/* <Icon ic={"IcClose"} size="s" onClick={() => {}} /> */}
        </p>
        <div
          onClick={() => setIsOpen(!isOpen)}
          className={`${classes["faq-toggle"]}`}
        >
          <div className={`${classes["icon-wrapper"]}`}>
            <Icon ic={"IcChats"} size="xl" />
          </div>
        </div>
      </div>

      {previewSrc && (
        <div className={classes["preview-overlay"]} onClick={closePreview}>
          <div
            className={classes["preview-image-wrapper"]}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={classes["close-btn"]} onClick={closePreview}>
              <Icon
                ic={"IcCloseRemove"}
                color="grey-100"
                kind=" background-bold"
                size="l"
              />
            </div>
            <img
              src={previewSrc}
              alt="Preview"
              className={classes["preview-image"]}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default FAQ;

const LeftEdge = () => {
  return (
    <svg
      viewBox="0 0 8 13"
      height="13"
      width="8"
      preserveAspectRatio="xMidYMid meet"
      class=""
      version="1.1"
      x="0px"
      y="0px"
      enable-background="new 0 0 8 13"
      style={{ color: "#ffffff" }}
    >
      <title>tail-in</title>
      <path
        opacity="0.13"
        fill="#0000000"
        d="M1.533,3.568L8,12.193V1H2.812 C1.042,1,0.474,2.156,1.533,3.568z"
      ></path>
      <path
        fill="currentColor"
        d="M1.533,2.568L8,11.193V0L2.812,0C1.042,0,0.474,1.156,1.533,2.568z"
      ></path>
    </svg>
  );
};

const RightEdge = () => {
  return (
    <svg
      viewBox="0 0 8 13"
      height="13"
      width="8"
      preserveAspectRatio="xMidYMid meet"
      class=""
      version="1.1"
      x="0px"
      y="0px"
      enable-background="new 0 0 8 13"
      style={{ color: "var(--color-primary-50)" }}
    >
      <title>tail-out</title>
      <path
        opacity="0.13"
        fill="#0000000"
        d="M5.188,1H0v11.193l6.467-8.625 C7.526,2.156,6.958,1,5.188,1z"
      ></path>
      <path
        fill="currentColor"
        d="M5.188,0H0v11.193l6.467-8.625C7.526,1.156,6.958,0,5.188,0z"
      ></path>
    </svg>
  );
};
const BotMsg = ({
  content = <p>Sorry, I could not understand. Could you please rephrase?</p>,
  role,
  isLastMsg,
  showIcon,
  onImageClick = () => { },
}) => {
  const handleClick = (event) => {
    if (event.target.tagName === "IMG") {
      if (event.target.src) {
        onImageClick(event.target.src);
      }
    }
  };
  return (
    <div
      className={`${classes["chat-container"]} ${classes["bot"]}`}
      id={isLastMsg ? "last-msg" : ""}
    >
      <div>
        <Icon ic={"IcChats"} />
      </div>

      <LeftEdge />

      <div
        className={`${classes["bot-chat"]} ${classes["chat-msg"]}`}
        onClick={handleClick}
      >
        {content}
      </div>
    </div>
  );
};
const PersonMsg = ({ content = "Unable to process", role, isLastMsg }) => {
  return (
    <div
      className={`${classes["chat-container"]} ${classes["person"]}`}
      id={isLastMsg ? "last-msg" : ""}
    >
      <div className={`${classes["person-chat"]} ${classes["chat-msg"]}`}>
        {content}
      </div>
      <RightEdge />
    </div>
  );
};
function greetingReturn() {
  const hour = new Date().getHours();
  let greeting = "";

  if (hour < 12) {
    greeting = "Good morning!";
  } else if (hour < 18) {
    greeting = "Good afternoon!";
  } else {
    greeting = "Good evening!";
  }

  return <p>{greeting}</p>;
}
const SuggestionTag = ({ lable, onClick = () => { }, sug }) => {
  return (
    <p
      className={`${classes["suggestion-tag"]}`}
      onClick={() => {
        onClick(sug);
      }}
      key={sug.key}
    >
      {lable}
    </p>
  );
};
